import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';

const contactData = [
    {
        id: uuidv4(),
        icon: <AiOutlineMail />,
        heading: 'Email Address',
        text: 'Get in touch for a consultation',
        item1: 'info@protopath.com.au',
        item2: 'enquiries@protopath.com.au',
    },

    {
        id: uuidv4(),
        icon: <AiOutlinePhone />,
        heading: 'Phone Number',
        text: 'Call us for immediate assistance',
        item1: '+61 4 9716 6742',
        item2: '',
    },

    {
        id: uuidv4(),
        icon: <FaMapMarkerAlt />,
        heading: 'Location',
        text: 'Servicing clients across Australia',
        item1: 'Australia',
        item2: 'Nationwide Service Available',
    },
];

export default contactData;
